// Arabisch (ar), golf2App: zelfde vorm als golf2App.nl.ts. De checklist bij een herinnering en
// vaste activiteiten met pauzes.
export const appChecklistAr = {
    title: 'قائمة التحقق',
    hint: 'ماذا يجب أن يأخذ معه؟ يعرض الجهاز اللوحي القائمة بجانب التذكير ويشطبها طفلك.',
    empty: 'لا شيء في القائمة بعد. اختر من الأسفل أو أضف شيئًا بنفسك.',
    suggestions: 'اقتراحات',
    suggestionAdd: 'إضافة {label}',
    addAll: 'إضافة الكل',
    newLabel: 'شيء آخر',
    newPlaceholder: 'مثلًا: نظارة سباحة',
    add: 'إضافة',
    labelRequired: 'اكتب كلمة.',
    labelTooLong: '40 حرفًا على الأكثر.',
    max: '12 شيئًا على الأكثر في كل قائمة.',
    itemPicto: 'صورة لـ {label}',
    up: '{label} إلى الأعلى',
    down: '{label} إلى الأسفل',
    remove: 'إزالة {label}',
    previewTitle: 'بجانب التذكير',
    sheetTitle: 'في الحقيبة',
    sheetProgress: '{done} من {total} في الحقيبة',
    sheetAllDone: 'كل شيء في الحقيبة',
    sheetNone: 'لم يُشطب شيء بعد',
    sheetItemDone: '{label}: في الحقيبة',
    sheetItemOpen: '{label}: ليس بعد',
    items: {
        'swim-trunks': 'شورت سباحة',
        swimsuit: 'لباس سباحة',
        towel: 'منشفة',
        underwear: 'ملابس داخلية',
        socks: 'جوارب',
        shampoo: 'شامبو',
        slippers: 'شبشب',
        'football-boots': 'حذاء كرة القدم',
        'shin-guards': 'واقي الساق',
        'water-bottle': 'قارورة ماء',
        quran: 'المصحف',
        backpack: 'الحقيبة',
        headscarf: 'حجاب',
        'prayer-cap': 'طاقية',
        coat: 'جاكيت',
        shoes: 'حذاء',
        lunch: 'الغداء',
        fruit: 'فاكهة',
        homework: 'الواجبات',
        reading: 'كتاب القراءة',
        'music-lesson': 'كتاب الموسيقى',
        'get-dressed': 'ملابس الرياضة',
    },
};
export const appActivitiesAr = {
    section: 'نشاط ثابت',
    toggle: 'هذا نشاط ثابت',
    toggleHint: 'مثل المدرسة أو درس المسجد أو كرة القدم: يستمر كل أسبوع، إلا في العطل والتوقفات التي تختارها أدناه.',
    needsRecurrence: 'اختر التكرار أولًا: النشاط الثابت يتكرر كل أسبوع.',
    followSchool: 'يتبع العطل المدرسية',
    followSchoolHint: 'لا يُقام هذا النشاط في العطل المدرسية لمنطقة {region}.',
    followSchoolNoRegion: 'اختر منطقة العطلات المدرسية من الإعدادات أدناه. تنطبق هذه المنطقة على الأسرة بأكملها.',
    regions: { noord: 'الشمال', midden: 'الوسط', zuid: 'الجنوب' },
    pauses: 'التوقفات',
    pausesHint: 'فترات يتوقف فيها هذا النشاط. يمكنك مشاركة التوقف مع أنشطة أخرى.',
    noPauses: 'لا توقفات بعد.',
    newPause: 'توقف جديد',
    pauseName: 'الاسم',
    pauseNamePlaceholder: 'توقف الصيف',
    pauseFrom: 'من',
    pauseTo: 'حتى (ضمنًا)',
    pauseAdd: 'إضافة توقف',
    pauseCancel: 'إلغاء',
    pauseNameRequired: 'أعطِ التوقف اسمًا.',
    pauseRangeInvalid: 'اختر تاريخ نهاية في يوم البداية أو بعده، خلال سنة.',
    pausePresets: {
        zomerstop: 'توقف الصيف',
        winterstop: 'توقف الشتاء',
        zomervakantie: 'العطلة الصيفية',
    },
    sharedWith: 'أيضًا في: {names}',
    saved: 'تم حفظ النشاط الثابت',
    saveFailed: 'تم حفظ الموعد، لكن لم تُحفظ التوقفات. حاول مرة أخرى.',
    barLabel: '{title}، {range}',
    schoolHoliday: 'عطلة مدرسية',
    pause: 'توقف',
    stops: 'متوقف: {names}',
    stopsNone: 'لا يتوقف أي نشاط ثابت في هذه الفترة.',
    sheetSchoolHint: 'مواعيد العطل المدرسية من الحكومة الهولندية، لمنطقتك. النشاط الثابت الذي يتبعها لا يُقام فيها.',
    sheetPauseHint: 'في هذه الفترة لا تُقام الأنشطة أدناه: لا تذكير ولا توصيل.',
    editPause: 'تعديل التوقف',
    deletePause: 'إزالة التوقف',
    deletePauseConfirm: 'هل أنت متأكد؟ ستستمر الأنشطة عندها كالمعتاد في هذه الفترة.',
    pauseDeleted: 'أُزيل التوقف «{name}»',
    pauseUpdated: 'حُفظ التوقف «{name}»',
    fixedChip: 'نشاط ثابت',
};
//# sourceMappingURL=golf2App.ar.js.map